(function(){
    'use strict';

    angular
    .module('app')
    .controller('SeoController', SeoController)
 
    SeoController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function SeoController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.datos = {};
        vm.fieldName = ""
        vm.datos.fbtitulo = "";
		vm.datos.fbdescripcion = "";
        vm.datos.twtitulo = "";
		vm.datos.page_id = "";
        vm.datos.twdescripcion = "";
        vm.datos.metadescription = "";
        vm.datos.metatype = "content";
		vm.datos.metakeywords = "";
		
		vm.datos.canonical = "";
		vm.datos.redirect = "";

		vm.update = function(){
			var json = angular.toJson(vm.datos);
			$timeout(function(){
				$('#'+vm.fieldName+"-jsonseo").val(json).trigger("change");
			});
		}

        vm.initVars = function(fieldName,value){
        	//console.log(value);
            if(value!=""){
        	   vm.datos = JSON.parse(value);
            }
            if(typeof vm.datos.robots == 'undefined'){
                vm.datos.robots = "index";
            }
             if(typeof vm.datos.metatype == 'undefined'){
                vm.datos.metatype = "content";
            }
            if(typeof vm.datos.follow == 'undefined'){
                vm.datos.follow = "follow";
            }
            if(typeof vm.datos.page_id == 'undefined'){
                vm.datos.page_id = "";
            }
            if(typeof vm.datos.frecuencia == 'undefined'){
                vm.datos.frecuencia = "weekly";
            }
            if(typeof vm.datos.prioridad == 'undefined'){
                vm.datos.prioridad = "0.5";
            }
            if(typeof vm.datos.metakeywords == 'undefined'){
                vm.datos.metakeywords = "";
            }
        	vm.fieldName = fieldName;
			//console.log(vm.datos);
            vm.update();
        }
    } 

})();